<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card :title="$t('Messages')">
      <b-row
        align-h="center"
      >
        <b-col
          cols="12"
        >
          <b-table
            sticky-header="1000px"
            no-border-collapse
            responsive
            striped
            hover
            :per-page="pageSize"
            :fields="messagesFields"
            :items="messages"
            :tbody-tr-class="rowClass"
            @row-clicked="onRowSelected"
          >
            <template #cell(text)="data">
              {{ data.text }}
              <span v-if="data.item.text.length < 10">
                {{
                  data.item.text
                }}
              </span>
              <span v-else>
                {{ data.item.text.slice(0,29) + '...' }}
              </span>
            </template>
            <template #cell(create_at)="data">
              <span>{{
                new Date(data.item["create_at"]).toLocaleString($i18n.locale)
              }}
              </span>
            </template>
          </b-table>
          <div
            v-if="!messages.length"
            class="text-center"
          >
            {{ $t('no_item_exsist') }}
          </div>

        </b-col>
        <b-pagination
          v-if="totalMessages > pageSize"
          v-model="currentPage"
          :total-rows="totalMessages"
          :per-page="pageSize"
          align="fill"
          size="sm"
          class="mt-2 mb-1"
        />
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import messages from '@/views/logics/messages'

export default {
  mixins: [messages],
}
</script>

<style>
.un-read-message {
  background-color: #ffe1e1 !important;
}
</style>
